import type { ELanguage } from '../languageHelper';

import { type ITextBase, oftenUsedTranslations } from './oftenUsed';

export interface IDashboardTexts extends ITextBase {
    dashboard_employee: string;
    dashboard_manager: string;
    dashboard_admin: string;
    noSettings: string;
    addWidget: string;
    newWidget: string;
    selectWidget: string;
    widgetLabels: {
        richTextWidget: string;
        personListWidget: string;
        buttonBoxWidget: string;
        agentChatWidget: string;
        onboardingWidget: string;
        notificationWidget: string;
    };
    systemStatus: string;
    activeUsers: string;
    systemHealth: string;
    pendingTasks: string;
    online: string;
}
type ILangData = {
    [lang in ELanguage]: IDashboardTexts;
};
export const dashboardTexts: ILangData = {
    th: {
        addWidget: 'เพิ่มวิดเจ็ต',
        newWidget: 'วิดเจ็ตใหม่',
        selectWidget: 'Choose Widget',
        widgetLabels: {
            personListWidget: 'รายชื่อพนักงาน',
            richTextWidget: 'การ์ดข้อความที่หลากหลาย',
            buttonBoxWidget: 'ปุ่มลิงก์',
            agentChatWidget: 'แชท AI',
            onboardingWidget: 'การปฐมนิเทศ',
            notificationWidget: 'การแจ้งเตือน',
        },
        oftenUsed: oftenUsedTranslations.th,
        noSettings: 'ไม่มีการตั้งค่าสำหรับวิดเจ็ตนี้',
        dashboard_employee: 'บอร์ดฝ่ายพนักงาน',
        dashboard_manager: 'บอร์ดฝ่ายผู้บริหาร',
        dashboard_admin: 'บอร์ดผู้ดูแลระบบ',
        systemStatus: 'สถานะระบบ',
        activeUsers: 'ผู้ใช้ที่ใช้งานอยู่',
        systemHealth: 'สุขภาพระบบ',
        pendingTasks: 'งานที่รอดำเนินการ',
        online: 'ออนไลน์',
    },
    en: {
        addWidget: 'Add widget',
        newWidget: 'New widget',
        selectWidget: 'Choose Widget',
        widgetLabels: {
            richTextWidget: 'Rich Text Widget',
            personListWidget: 'Employee List',
            buttonBoxWidget: 'Link button',
            agentChatWidget: 'AI-Chat',
            onboardingWidget: 'Onboarding',
            notificationWidget: 'Notifications',
        },
        oftenUsed: oftenUsedTranslations.en,
        noSettings: 'There are no settings for this widget.',
        dashboard_employee: 'Employee Dashboard',
        dashboard_manager: 'Manager Dashboard',
        dashboard_admin: 'Admin Dashboard',
        systemStatus: 'System Status',
        activeUsers: 'Active Users',
        systemHealth: 'System Health',
        pendingTasks: 'Pending Tasks',
        online: 'Online',
    },
    de: {
        oftenUsed: oftenUsedTranslations.de,
        newWidget: 'Neues Widget',
        addWidget: 'Widget hinzufügen',
        selectWidget: 'Widget auswählen',
        widgetLabels: {
            richTextWidget: 'Rich Text Widget',
            personListWidget: 'Mitarbeiter-Liste',
            buttonBoxWidget: 'Link-Button',
            agentChatWidget: 'KI-Chat',
            onboardingWidget: 'Onboarding',
            notificationWidget: 'Benachrichtigungen',
        },
        noSettings: 'Es gibt für dieses Widget keine Einstellungen.',
        dashboard_employee: 'Mitarbeiter-Dashboard',
        dashboard_manager: 'Führungskraft-Dashboard',
        dashboard_admin: 'Admin-Dashboard',
        systemStatus: 'System Status',
        activeUsers: 'Aktive Benutzer',
        systemHealth: 'System Health',
        pendingTasks: 'Pending Tasks',
        online: 'Online',
    },
};
